import type { StyleRule } from '@archipro-design/aria';

export const ProductTaggingContainer: StyleRule = () => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    // The box positions the tags; it is not itself a control. It mounts for
    // anyone who may create a tag, tagging or not, and covered the whole
    // picture — so on an article, where the picture opens the photo viewer,
    // a staff reader could not open a single body image. The surface that
    // does take clicks is `ProductTaggingClickableArea`, which only mounts
    // while tagging and takes its events back.
    pointerEvents: 'none',

    // The markers used to be revealed from here, on this box's own `:hover`.
    // A box that takes no pointer events never receives one, so that rule was
    // dead the moment the line above landed. Each marker keys off the host
    // figure's `group` instead — see `TagWithModals`.
});
